import React, { Component } from 'react'
import './Footer.css'
import {ArrowForward} from '@material-ui/icons';
import LongArrow from '../../../assets/long-arrow-right-copy-10.png'
import logo from '../../../assets/logo.png'
import IG from '../../../assets/IG.png'
import fb from '../../../assets/fb.png'
import twitter from '../../../assets/twitter.png'
import { Link } from "gatsby"


export default class Footer extends Component {
    render() {
        return (
          <div className="container-fluid top-space-padding pt-5" >
            <div className="row no-gutters">
              <div className="col-3 col-sm-3 col-md-2 d-flex align-items-left align-items-sm-left justify-content-start justify-content-sm-start">
                
                <img src={logo} className="logo-image" style={{marginBottom : '0px'}}/>
              </div>
            
            </div>
          <div className="row top-space-padding foot-space no-gutters" >
              <div className="col-4 col-sm-7 col-md-6 nav-col-position pl-1 pl-sm-5 pl-md-1">
              <ul className="nav-list-col">
                  <li><Link to={`/`} style={{color : 'black'}}>BROADCASTS</Link></li>
                  <li><Link to={`/blog/page/1`}  style={{color : 'black'}}>BLOG</Link ></li>
                  <li><Link to={`/work`} style={{color : 'black'}}>CONTACT</Link></li>
                  <li><Link to={`/about`} style={{color : 'black'}}>ABOUT</Link></li>

              </ul>
              </div>
              <div className="col-0 col-md-0 col-sm-0 col-lg-0">

              </div>
              <div className="col-8 col-sm-5 col-md-6 pt-2 pt-sm-2 pt-md-5" style={{paddingRight :'0px', paddingLeft :'0px'}} >
                {/* <div className="d-flex  justify-content-sm-end justify-content-end row icons no-gutters">
                  <div className="col-0 col-sm-3 col-md-6 col-lg-6 col-xl-9"></div>
                 <div className="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-1 icon1"  >

                <img src={fb} height="24" className="fb" />
                   </div>
                   <div className="col-4 col-sm-3 col-md-2 col-lg-2 col-xl-1 icon2"  >
                <img src={IG}  className="insta"/>
                   </div>
                   <div className="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-1 icon3" >
                <img src={twitter}  height="22" className="twitter"/>
                   </div>
                </div>
               
                */}
                <div className="  justify-content-sm-end justify-content-end row icons no-gutters">
                <ul className="social-network social-circle">
             <li><a href="https://www.facebook.com/profile.php?id=100004235748003" className="Facebook" title="Facebook"><img src={fb} height="24" className="fb" /></a></li>
             <li><a href="https://www.instagram.com/cwotgwot/" className="Instagram" title="Instagram">  <img src={IG}  className="insta"/></a></li>
             <li><a href="https://twitter.com/selectedwisdom?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" className="Twitter" title="Twitter"> <img src={twitter}  height="22" className="twitter"/></a></li>
            </ul>	
            </div>
              <div className=" d-flex  justify-content-sm-end justify-content-end" >
                <p className="copy-right">Copyright 2020 - Selectedwisdom.com</p>
              </div>
              </div>
          </div>
          </div>
        )
    }
}
